import {
  DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL,
  DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL_SUCCESS,
  DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL_ERROR,
  DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL_EMPTY,
} from '../../actions.js';

const initialState = { data: null, loading: false, error: null };

const DownloadManualBookingSummaryExcel = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL:
      return { ...state, loading: true, data: null, error: null };
    case DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL_ERROR:
      return { ...state, loading: false, error: action.payload };
    case DOWNLOAD_MANUAL_BOOKING_SUMMARY_EXCEL_EMPTY:
      return { ...initialState };
    default:
      return state;
  }
};

export default DownloadManualBookingSummaryExcel;
